module.exports = __webpack_public_path__ + "img/testbanner.9956c1b9.png";